import { Factory } from './Factory'
import { TabFactory } from './TabFactory'
import Menu from '../EditorComponents/Accordion/Menu'

export class AccordionFactory extends Factory {
	constructor(qty = 1) {
		super()
		this.qty = qty
	}

	object() {
		return {
			id: this.id('accordion'),
			iconId: this.id('accordion-icon'),
			iconContainerId: this.id('accordion-icon-container'),
			slug: 'editor-accordion',
			assets: {
				phone: [],
				tablet: [],
				desktop: []
			},
			background: {
				phone: 'color',
				tablet: 'color',
				desktop: 'color'
			},
			customClasses: [],
			constantClasses: {
				phone: [],
				tablet: [],
				desktop: []
			},
			sections: (new TabFactory).create(),
			name: 'Accordion',
		}
	}

  properties() {
    return {
      content: [
        {key: 'has-icon', component:'ContentToggle', text:'has an Icon', property:'hasIcon'},
        {key: 'icon-content', component:'ContentIcon'},
        {key: 'several-open', component:'ContentToggle', text:'open multiple', property:'severalOpen'},
      ],
      styles: [
        {key: 'margin', component:'MarginProperty'},
      ],
      titleStyles: [
        {key: 'background-color', component:'BackgroundProperty', only: ['color'], class: 'titleClasses', styles:'titleStyles'},
        {key: 'border', component:'BorderProperty', class: 'titleClasses', styles:'titleStyles'},
        {key: 'font-size', component: 'FontSizeProperty', class: 'titleClasses'},
        {key: 'font-weight', component: 'FontWeightProperty', class: 'titleClasses'},
        {key: 'active-title-color', text: 'Active Color', component:'TextColorProperty', styles:'activeTitleStyles'},
        {key: 'inactive-title-color', text: 'Inactive Color', component:'TextColorProperty', styles:'inactiveTitleStyles'},
        {key: 'active-chevron-color', text: 'Chevron Active Color', component:'TextColorProperty', styles:'activeChevronStyles'},
        {key: 'inactive-chevron-color', text: 'Chevron Inactive Color', component:'TextColorProperty', styles:'inactiveChevronStyles'},
        {key: 'padding', component:'PaddingProperty', class: 'titleClasses'},
      ],
      containerStyles: [
        {key: 'margin', component:'MarginProperty', class: 'containerClasses'},
      ],
      iconStyles: [
        {key: 'background-color', component:'BackgroundProperty', only: ['color'], class: 'iconContainerClasses', styles:'iconContainerStyles'},
        {key: 'border', component:'BorderProperty', class:'iconContainerClasses', styles: 'iconContainerStyles'},
        {key: 'rounded', component:'RoundedProperty', class:'iconContainerClasses'},
        {key: 'text-color', component:'TextColorProperty', styles: 'iconStyles'},
      ],
      advanced: [
        {key: 'element-id', component: 'ElementId'},
        {key: 'custom-classes', component: 'CustomClasses'},
        {key: 'custom-styles', component: 'CustomStyles'},
      ],
      menu: Menu
    }
  }
}
